import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Glossary from "@/pages/Glossary";
import { buildGlossaryJsonLd } from "@/lib/seo/glossaryJsonLd";

export const Route = createFileRoute("/en/knowledge-center/glossary/")({
  head: () => ({
    ...buildRouteHead("/en/knowledge-center/glossary"),
    scripts: buildGlossaryJsonLd("en", "/en/knowledge-center/glossary"),
  }),
  component: Glossary,
});
